"use strict";

const SmartFilterRegistry = function () {
  const registry = new Map();
  let activeKey = null;
  let filterSummary = null;

  function set(key, smartFilter) {
    if (!key) {
      throw new Error("SmartFilterRegistry: key is required");
    }
    clear(key);
    registry.set(key, smartFilter);
    activeKey = key;
  }

  function get(key) {
    return registry.get(key);
  }

  function clear(key = activeKey) {
    get(key)?.destroy();
    registry.delete(key);

    if (activeKey === key) {
      activeKey = null;
    }
  }

  function getActive() {
    const active = get(activeKey);

    if (active) {
      return active;
    }

    if (Tree.get("activeTab") === "todo") {
      return ToDoFilters.getLastSmartFilter();
    }
    filterSummary?.setFieldDefinitionMap(
      DataViewFunctions.getCurrentDataViewProperty("filterFields") ?? [],
    );
    return Filters.getLastSmartFilter();
  }

  function getSummary() {
    let filterFields;

    if (
      Tree.get("tool") === "esg" ||
      window.jestTestsRunning ||
      !(filterFields = DataViewFunctions.getCurrentDataViewProperty("filterFields"))
    ) {
      return null;
    }

    if (!filterSummary) {
      filterSummary = new FilterSummary($(".main-filter-summary"), "filters", filterFields, [
        "data",
      ]);
    }

    return filterSummary;
  }

  return {
    set,
    get,
    clear,
    getActive,
    getSummary,
  };
};

module.exports = SmartFilterRegistry();

const Tree = require("../tree");
const Filters = require("../mapFunctions/filters");
const ToDoFilters = require("../mapFunctions/toDoFilters");
const FilterSummary = require("./filterSummary");
const DataViewFunctions = require("../dataViewFunctions");
